import { AppState, State } from './app.state';
import { createSelector } from '@ngrx/store';

export const selectApp = (state: State) => state.app;
export const selectAppUser = createSelector(selectApp, (state: AppState) => state.user);
export const selectAppLocale = createSelector(selectApp, (state: AppState) => state.locale);
export const selectAppBranding = createSelector(selectApp, (state: AppState) => state.branding);
export const selectAppTranslations = createSelector(selectApp, (state: AppState) => state.translations);
export const selectAppCurrentPage = createSelector(selectApp, (state: AppState) => state.currentPage);
